import React from 'react';
import { graphql } from 'gatsby';
import isNil from 'utils/isNil';
import useGlobalFooter from 'hooks/useGlobalFooter';
import WebsiteLayout from '../layouts/websiteLayout';
import CareerHero from '../components/Careers/CareersHero';
import CareersAwards from '../components/Careers/CareersAwards';
import CareersVision from '../components/Careers/CareersVision';
import CareersValuesCarousel from '../components/Careers/CareerValuesCarousel';
import CareersLifeHoverSection from '../components/Careers/CareersLifeHover';
import CareersPerksSection from '../components/Careers/CareersPerks';
import CareersCulture from '../components/Careers/CareersCulture';
import CareersLocation from '../components/Careers/CareersLocation';
import CareersTimeline from '../components/Careers/CareersTimeline';
import SEO, { createSEO } from '../components/SEO';

const CareerPage = props => {
  const { pastMilestones, futureMilestones } = props.data.contentfulCareersPage;
  const websiteHeader = props.data.contentfulWebsiteHeader;
  const footer = useGlobalFooter();

  const pageImages = props.data.allContentfulWebsiteImage;
  let heroBackground;
  let awardDeloitte;
  let awardLABJ;
  let awardForbes;
  let awardInc500;
  let awardIncBest;
  let visionImg;
  let valuesChangeLives;
  let lifeImpact;
  let lifeIntrapenuership;
  let lifeAcceleration;
  let perkHealth;
  let perkFamily;
  let perkFinance;
  let perkBeach;
  let perkLifestyle;
  let perkCommunity;
  let cultureGroups;
  let culturePrograms;
  let locationsLA;
  let locationsATL;
  let locationsYerevan;
  let locationsColumbus;
  let lifeCollage;
  let valuesExtraordinary;
  let valuesTeam;
  let visionMobile;
  pageImages.edges.forEach(imageItem => {
    if (imageItem.node.internalName === 'Careers Hero Background') {
      heroBackground = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers Awards - Deloitte Fast 500') {
      awardDeloitte = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers Awards - LABJ Fastest 100') {
      awardLABJ = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers Awards - Forbes Cloud 100') {
      awardForbes = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers Awards - INC 500') {
      awardInc500 = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers Awards - Inc Best') {
      awardIncBest = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers - vision image') {
      visionImg = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers - values image collage') {
      valuesChangeLives = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers - JonDelina Buckley') {
      lifeImpact = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers - Leslie Gildea') {
      lifeIntrapenuership = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers - Vach Hovsepyan') {
      lifeAcceleration = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers - Groups BG Image') {
      cultureGroups = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers - Programs BG Image') {
      culturePrograms = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers - Perks Icon') {
      perkBeach = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers - Perks Health Icon') {
      perkHealth = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers - Lifestyle Icon') {
      perkLifestyle = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers - financial') {
      perkFinance = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers - family planning') {
      perkFamily = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers - Community Icon') {
      perkCommunity = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers > Locations > LA') {
      locationsLA = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers > Locations > Atlanta') {
      locationsATL = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers > Locations > Yerevan') {
      locationsYerevan = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Careers > Locations > Columbus') {
      locationsColumbus = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'careers-life-collage') {
      lifeCollage = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'careers - achieve the extraordinary') {
      valuesExtraordinary = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'careers - dream team') {
      valuesTeam = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'careers ara and vahe fathers') {
      visionMobile = !isNil(imageItem?.node?.image) ? imageItem?.node?.image?.fluid.src : '';
    }
  });

  const seo = createSEO(
    {
      ...props.data.contentfulCareersPage,
      pageCategory: 'Company',
    },
    props
  );

  return (
    <WebsiteLayout
      header={websiteHeader}
      hero={{ background: 'red' }}
      background="White"
      heroFromTop
      landingPage
      navigation={websiteHeader.navigation}
      footer={footer}
    >
      <SEO {...seo} />
      <CareerHero
        backgroundImg={!isNil(heroBackground) ? heroBackground : ''}
        title="DEMOCRATIZING THE POWER OF TECHNOLOGY"
        titleColor="white"
        buttonTitle="View Job Openings"
        buttonType="secondary"
        buttonTitleColor="white"
        buttonLinkTo="/job-openings"
      />
      <CareersAwards
        id="careers-awards"
        awardOne={awardDeloitte}
        awardTwo={awardLABJ}
        awardThree={awardForbes}
        awardFour={awardInc500}
        awardFive={awardIncBest}
      />
      <CareersVision id="careers-vision" img={visionImg} mobileImg={visionMobile} />
      <CareersValuesCarousel
        id="careers-culture"
        slideOneImg={valuesChangeLives}
        slideTwoImg={valuesExtraordinary}
        slideThreeImg={valuesTeam}
      />
      <CareersLifeHoverSection
        id="careers-life"
        lifeImpact={lifeImpact}
        lifeIntrapenuership={lifeIntrapenuership}
        lifeAcceleration={lifeAcceleration}
        lifeCollage={lifeCollage}
      />
      <CareersPerksSection
        id="careers-perks"
        perkHealth={perkHealth}
        perkFamily={perkFamily}
        perkFinance={perkFinance}
        perkLifestyle={perkLifestyle}
        perkBeach={perkBeach}
        perkCommunity={perkCommunity}
      />
      <CareersCulture
        id="careers-culture"
        cultureGroups={cultureGroups}
        culturePrograms={culturePrograms}
      />
      <CareersLocation
        id="careers-location"
        locationsLA={locationsLA}
        locationsATL={locationsATL}
        locationsYerevan={locationsYerevan}
        locationsColumbus={locationsColumbus}
      />
      <CareersTimeline
        title="Milestones"
        pastMilestones={pastMilestones}
        futureMilestones={futureMilestones}
      />
    </WebsiteLayout>
  );
};

export default CareerPage;

export const CareerPageQuery = graphql`
  query CareerPageQuery {
    contentfulCareersPage {
      canonicalUrl
      slug
      pageTitle
      metaDescription {
        metaDescription
      }
      indexable
      socialSharingImage {
        ... on ContentfulWebsiteImage {
          alt
          image {
            file {
              url
            }
          }
        }
      }
      pastMilestones {
        title
        iconType
        description
      }
      futureMilestones {
        title
        iconType
        description
      }
    }
    allContentfulWebsiteImage(
      filter: {
        contentful_id: {
          in: [
            "6gqkB7m4FAvuRf5ucuO9R4" #Careers - Glassdoor White
            "2ko4KSsK15r0ZWj7R2eakw" #Careers Hero Background
            "4yWPob8pYhVEsUTQcJlOFe" #Careers Awards - Deloitte Fast 500
            "2FXwsU32cxF7sPoF5Tywom" #Careers Awards - LABJ Fastest 100
            "7rs2LU89oFNfBYjm3lqIGW" #Careers Awards - Forbes Cloud 100
            "3LWG57kIKnPnTM4IKhxK2" #Careers Awards - INC 500
            "6fbVlyqJMozQsvOOOKKaKF" #Careers Awards - Inc Best
            "7emGT9OpmOEu9wNAotYYUF" #Careers - vision image
            "7ogSHrr0rES5S6igikjZjZ" #Careers - values image collage
            "5fqULgZOH7IorXcHwIRbcb" #Careers - JonDelina Buckley
            "43zT2jqz0pJIvPdh9BabeA" #Careers - Leslie Gildea
            "3AoU1EQOzH9bET3giY0g0z" #Careers - Vach Hovsepyan
            "2zjG3WCJ953y6ENJVd6wp" #Careers - family planning
            "6JWuwoJJhf3QRDMBMcLcwJ" #Careers - financial
            "26MKmIlI3vOJ1ySEFT9XM3" #Careers - Lifestyle Icon
            "4FgrYHq5DolbU4D18JGksJ" #Careers - Groups BG Image
            "2HgRqCplBHKU1PYRRHRMEn" #Careers - Programs BG Image
            "1sAEJ58lx5U0r3NHWaevaD" #Careers - Perks Health Icon
            "1EMpqm62MryK1B6jOhjHqU" #Careers - Perks Icon
            "3VknlIwLjIPGMBc0mthffO" #Careers - Community Icon
            "3Bdq0Eh01ga8v3CFNNwpHK" #Careers > Locations > LA
            "tt1M7KfxABVsIgHJx6133" #Careers > Locations > Atlanta
            "54498QNIV2Edf2TDrigQql" #Careers > Locations > Yerevan
            "2RzIx5Hu7BiV7whiUH2i98" #Careers > Locations > Columbus
            "1kPgGHBGqM6YWNloIYlYow" #careers-life-collage
            "NUBfZr0fczhCZQl4pHm3f" #careers - achieve the extraordinary
            "6VSlbL1Bq05sj0nwvLDt4S" #careers - dream team
            "3CYkLb1U0WPSEBDxrvSutt" #careers ara and vahe fathers
          ]
        }
      }
    ) {
      edges {
        node {
          internalName
          image {
            fluid(quality: 100) {
              ...GatsbyContentfulFluid_withWebp_noBase64
            }
          }
        }
      }
    }
    contentfulWebsiteHeader(contentful_id: { eq: "6AT1SuVB0Xl2hEwxiGwW1U" }) {
      logoRoute
      navigation {
        ... on ContentfulNavigation {
          navigation {
            ... on ContentfulNavigationElement {
              internalName
              group {
                group
              }
              icon {
                ... on ContentfulWebsiteImage {
                  alt
                  image {
                    file {
                      url
                    }
                  }
                }
              }
              label
              url
              description
              subNavigationElement {
                ... on ContentfulNavigationElement {
                  ... on ContentfulNavigationElement {
                    internalName
                    group {
                      group
                    }
                    icon {
                      ... on ContentfulWebsiteImage {
                        alt
                        image {
                          file {
                            url
                          }
                        }
                      }
                    }
                    label
                    url
                    description
                  }
                }
              }
            }
          }
        }
      }
      contextualCta {
        ... on ContentfulCallToAction {
          buttonLabel
          url
        }
        ...InlineMarketingForm
      }
    }
  }
`;
